import { type FC } from 'react';

import Script from 'next/script';
import { jsonLdScriptProps } from 'react-schemaorg';
import { type Thing, type WithContext } from 'schema-dts';

type Props = {
	schemaItem: Thing;
	id: string;
	isDataDynamic?: boolean;
};

export const StructuredData: FC<Props> = ({ schemaItem, id, isDataDynamic }) => {
	const thingWithContext = Object.assign(schemaItem, {
		'@context': 'https://schema.org',
	}) as WithContext<Thing>;

	return isDataDynamic ? (
		/*The Script from next/script is loaded only once. Changing it to regular script tag is fixing the issue and data is displayed.
		Next.js will ensure the script will only load once, even if a user navigates between multiple routes in the same layout */
		<script id={id} type="application/ld+json" {...jsonLdScriptProps<Thing>(thingWithContext)} />
	) : (
		<Script
			id={id}
			type="application/ld+json"
			strategy="beforeInteractive"
			{...jsonLdScriptProps<Thing>(thingWithContext)}
		/>
	);
};
